import AuthLayout from "../../../layouts/AuthLayout/AuthLayout";
import Error from "../components/Error";
import Form from "../components/Form";
import Input from "../components/Form/Input";
import Button from "../components/Form/Button";
import {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import { verify } from "../api";
import useAuth from "../../../shared/hooks/useAuth";
import LoadingContext from "../../../app/contexts/LoadingContext";
import {loginError} from "../../../store/slices/AuthSlice";
import {useDispatch} from "react-redux";
function Verify() {
    const [otp,setOtp] = useState();
    const [isError,setIsError]  = useState(false);
    const [errorMessage,setErrorMessage] = useState('');
    const navigate = useNavigate();
    const deviceId = localStorage.getItem('deviceId');
    const { signIn } = useAuth();
    const dispatch = useDispatch();
    const {setLoading} = useContext(LoadingContext)
    const handleSubmit = async () => {
        setLoading(true);
        const response = await verify(deviceId,otp);
        if (!response.success) {
            dispatch(loginError({
                message: response.message
            }));
            setIsError(true);
            setErrorMessage(response.message);
        }
        else {
            const data = response.data;
            signIn(data);
            navigate("/");
        }
        setLoading(false);
    }
    useEffect(() => {
        if (!deviceId || deviceId.length <= 0) {
            navigate('/auth/login');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <AuthLayout title="Xác minh bảo mật Google Authenticate" error={isError && <Error>{errorMessage}</Error>}>
            <Form>
                <Input label={"Nhập mã xác minh"} type={"text"} onChange={(e) => setOtp(e.target.value)} />
                <Button onClick={handleSubmit}>Xác nhận</Button>
            </Form>
        </AuthLayout>
    );
}
export default Verify;